import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import MarketingLanding from './components/MarketingLanding';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import HelpCenter from './pages/HelpCenter';
import ReportThreat from './pages/ReportThreat';
import ComingSoon from './pages/ComingSoon';
import QuarantineManager from './pages/QuarantineManager';
import AdminLicenseManager from './components/AdminLicenseManager';
import { DisclaimerPage, PrivacyPolicyPage, TermsOfServicePage } from './components/LegalPages';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

const AppRouter = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<MarketingLanding />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <App />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <App />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quarantine"
            element={
              <ProtectedRoute>
                <QuarantineManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/licenses"
            element={
              <ProtectedRoute>
                <AdminLicenseManager />
              </ProtectedRoute>
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          {/* Pages taken down Oct 2026 until rewritten: they contained internal notes or claims
              CyberGuard can't support. The page files are kept in src/pages. */}
          <Route path="/documentation" element={<Navigate to="/" replace />} />
          <Route path="/partners" element={<Navigate to="/" replace />} />
          <Route path="/blog" element={<Navigate to="/" replace />} />
          <Route path="/blog/:articleId" element={<Navigate to="/" replace />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/emergency" element={<Navigate to="/contact" replace />} />
          <Route path="/report-threat" element={<ReportThreat />} />
          <Route path="/advisories" element={<Navigate to="/" replace />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default AppRouter;